<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="75%">
    <v-card class="px-3 pt-0 pb-2">
      <v-card-title class="pa-0">
        <v-col class="text-right pb-0 pt-1 px-0">
          <v-btn icon dark @click="cleanClose()">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col class="text-center py-0" cols="12">
          <h1 style="font-size: 26px" class="mb-1 pt-0">Pendências do lote</h1>
          <b>Arquivo:</b><p class="mb-0 mt-0">{{dadosDoLote.arq_nome}}</p>
        </v-col>
        <v-row>
          <v-col class="px-10 py-1" cols="12" sm="4" md="3">
            <b class="texts">Número do lote:</b>
            <p class="texts mb-0">{{dadosDoLote.arq_numero_lote}}</p>
          </v-col>

          <v-col class="px-10 py-1" cols="12" sm="4" md="3">
            <b class="texts">Importação:</b>
            <p class="texts mb-0">{{dadosDoLote.upload_dt | formatDate}}</p>
          </v-col>

          <v-col class="px-10 py-1" cols="12" sm="4" md="3">
            <b class="texts">Número de guias:</b>
            <p class="texts mb-0">{{dadosDoLote.arq_qtd_guias}}</p>
          </v-col>

          <v-col class="px-10 py-1" cols="12" sm="4" md="3">
            <b class="texts">Valor informado (R$):</b>
            <p v-if="dadosDoLote.arq_vl_informado == dadosDoLote.arq_vl_calculado" class="texts mb-0">{{ dadosDoLote.arq_vl_informado | formatPrice }}</p>
            <p v-if="dadosDoLote.arq_vl_informado != dadosDoLote.arq_vl_calculado" class="mb-0" style="color:#FC9E0D;font-size:14px">
                <b>{{dadosDoLote.arq_vl_informado | formatPrice}}</b>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }" >
                    <span  style="color:#FC9E0D" v-bind="attrs" v-on="on" class="pa-0">
                      <v-icon x-small class="px-1" color="orange">fa-exclamation-triangle</v-icon>
                    </span>
                  </template>
                  <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">Valor calculado diferente do informado</span>
                </v-tooltip>
            </p> 
          </v-col>

          <v-col class="px-10 py-2" cols="12" sm="4" md="3">
            <b class="texts">Tipo de guia:</b>
            <p class="texts mb-0">{{dadosDoLote.tipo_guia_descricao}}</p>
          </v-col>

          <v-col class="px-10 py-2" cols="12" sm="4" md="3">
            <b class="texts">Ident. do prestador:</b>
            <p class="texts mb-0">{{dadosDoLote.env_op_dt | formatDate}}</p>
          </v-col>

          <v-col class="px-10 py-2" cols="12" sm="4" md="3">
            <b class="texts">Versão do TISS:</b>
            <p class="texts mb-0">{{dadosDoLote.arq_versao}}</p>
          </v-col>

          <v-col class="px-10 py-2" cols="12" sm="4" md="3">
            <b class="texts">Valor calculado (R$):</b>
            <p class="texts mb-0">{{dadosDoLote.arq_vl_calculado | formatPrice}}</p>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="py-0">
        <ErroLote
          v-show="true"
          :itemsErro="error"
          :listEnvio="envio"
          :critica="critica"
          :showType="errorType == 1? errorType : type"
          :cleanClose="() => cleanClose()"
          :dadosLote="dadosDoLote"
          :envioAutomatico="parameter"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
moment.locale("pt-BR");
import ErroLote from '@/components/faturamento/dados_cronograma/LoteErro'
export default {
  components: {
    ErroLote
  },
  data() {
    return {
      type: 'error',
      envio: [],
    };
      // criticaLote: null,
      // criticaGuia: null
  },
  filters: {
    formatDate(date) {
      if (!date) return null
      return moment(date).format("L");
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  methods: {
    cleanClose() {
      this.showClose(false)
    }
  },
  props: {
    dialog: Boolean,
    showClose: Function,
    dadosDoLote: Object,
    error: Object,
    critica: Object,
    parameter: Boolean,
    showValue: String,
    errorType: Number,
    userData: Object,
  },
};
</script>

<style>
.texts {
  color: #4a4a4a;
  font-size: 14px;
  line-height: 23px;
}
.ematraso {
  color: #FC9D0A;
  font-weight: bold;
}
</style>